import { ControllerAPI } from "../api/api";
import createListApiState from "./lib/ListApiState";

export const [
    workersSlice,
    loadWorkers,
    updateWorkersManually
] = createListApiState({
    name: "Workers",
    execute: ControllerAPI.loadWorkers
});
